import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import formattersService from '../../../services/formatters';

import Buff from '../../common/buff';
import './newsletter-box.css';

class NewsletterBox extends Component {
  render() {
    const tag = this.props.tag;
    const linkToArticle = `/newsletters${tag !== 'angular' ? `/ag/${tag}` : '' }/${this.props._id}`;
    
    let mainImg = (tag === 'angular' && this.props._id < 119) ? `/images/newsletters/${this.props._id}/mix.png` : this.props.mainImg;

    return (
      <article className='newsletter-box'>
        <Link to={linkToArticle} title={`Newsletter #${this.props._id}`}>
        
          { this.props.buffText ? <Buff text={this.props.buffText} /> : '' }

          <div className='newsletter-box-exclude-buff'>
            <div className='newsletter-image-container'>
              <div className='newsletter-image'
                   style={{'backgroundImage': `url("${mainImg}")`}}>
              </div>
            </div>

            <div className='image-bottom-bar newsletter-bottom-bar-container'>
              <h3>#{this.props._id}</h3>
              <span>{formattersService.formatDate(this.props.date)}</span>
            </div>
          </div>
        </Link>          
      </article>
    );
  }
}

NewsletterBox.propTypes = {
  _id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
  })).isRequired,
  mainImg: PropTypes.string,
  buffText: PropTypes.string,
  tag: PropTypes.string,
};

export default NewsletterBox;